import ListResourceGridComponent from './ListResourceGridComponent';
export default ListResourceGridComponent;
